interface Miesiac {
  id: number;
  wartosc: string;
}

export const months: Miesiac[] = [
  {
    id: 1,
    wartosc: $localize`styczeń`,
  },
  {
    id: 2,
    wartosc: $localize`luty`,
  },
  {
    id: 3,
    wartosc: $localize`marzec`,
  },
  {
    id: 4,
    wartosc: $localize`kwiecień`,
  },
  {
    id: 5,
    wartosc: $localize`maj`,
  },
  {
    id: 6,
    wartosc: $localize`czerwiec`,
  },
  {
    id: 7,
    wartosc: $localize`lipiec`,
  },
  {
    id: 8,
    wartosc: $localize`sierpień`,
  },
  {
    id: 9,
    wartosc: $localize`wrzesień`,
  },
  {
    id: 10,
    wartosc: $localize`październik`,
  },
  {
    id: 11,
    wartosc: $localize`listopad`,
  },
  {
    id: 12,
    wartosc: $localize`grudzień`,
  },
];
